<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (dragover)="dragOver()" class="folders-list" draggable="false">
    @for (folder of foldersToShow(); track folder.id) {
        <div
                class="folders-list__item folder"
                [ngClass]="{ active: drugOverFolderId === folder.id }"
                (dblclick)="openChildFolder(folder.id)"
                (dragover)="projectDragAndDropService.drugOver($event); dragOver(folder.id)"
                (drop)="projectDragAndDropService.drop(folder); dragOver()"
        >
            <button windeTransparent>
                <sui-svg-icon class="folder__icon" icon="folder" windeGrey/>
                <span class="folder__name" draggable="false">
                    <winde-highlight-text [text]="folder.name" [searchSubstring]="searchFilter()"></winde-highlight-text>
                </span>
            </button>
            <div class="folder__controls" draggable="false" *windeHasAnyAuthority="userAuthorities.PROJECT_EDIT">
                <winde-ctx-sensitive-help
                        placement="right"
                        tooltipTextPath="projects.folder.btn.edit"
                        [routerLink]="['', { outlets: { popup: ['folder', folder.id, 'edit'] } }]"
                        queryParamsHandling="preserve"
                >
                    <button windeActionIcon>
                        <sui-svg-icon icon="pencil" windeOrange/>
                    </button>
                </winde-ctx-sensitive-help>
                <winde-ctx-sensitive-help
                        placement="right"
                        tooltipTextPath="projects.folder.btn.remove"
                        [routerLink]="['', { outlets: { popup: ['folder', folder.id, 'delete'] } }]"
                        queryParamsHandling="preserve"
                >
                    <button windeActionIcon>
                        <sui-svg-icon icon="cross" windeRed/>
                    </button>
                </winde-ctx-sensitive-help>
            </div>
        </div>
    }
</div>
